// ============================================================================
// CE QU'UN ÉCRAN DIT DE SON PROPRE RAFRAÎCHISSEMENT — la cadence, et le repère de fraîcheur.
//
// UTILITÉ : le back-office n'a AUCUN canal vers le navigateur. Un appareil qui pousse (Mobile Partner
// qui envoie un contrôle de réception, une tablette qui remonte une zone comptée) n'atteint pas la
// page : c'est la page qui INTERROGE. Deux écrans le font désormais — l'inventaire et les réceptions —
// donc la règle vit ici, une fois, plutôt que recopiée à la deuxième (règle de 2, §24.3).
//
// ⚠️ « DERNIÈRE VÉRIFICATION », JAMAIS « EN DIRECT ». Un bandeau « en direct » sur une page qui
// n'écoute rien laisserait croire qu'un contrôle absent n'est pas encore arrivé, alors qu'il peut
// être là depuis dix minutes (§23.0).
// ⚠️ ET C'EST CE REPÈRE QUI REND UN BATTEMENT RATÉ VISIBLE : un rafraîchissement en échec est avalé
// (il ne doit pas casser l'écran), mais l'heure cesse alors d'avancer — l'écran le DIT sans rien
// interrompre. Sans lui, l'échec serait vraiment silencieux.
// ============================================================================

/** Cadence d'interrogation d'un écran qui attend l'arrivée d'un appareil. */
import { t } from '../i18n';
export const CADENCE_RAFRAICHISSEMENT_MS = 15_000;

/**
 * Ce que l'écran affiche de son propre rafraîchissement.
 * ⚠️ `null` = on n'a pas encore regardé une seule fois : dire « il y a 0 s » serait faux.
 */
export function derniereVerification(at: number | null, maintenant: number): string {
  if (at == null) return t('pas encore vérifié');
  const secondes = Math.max(0, Math.round((maintenant - at) / 1000));
  if (secondes < 5) return t('vérifié à l’instant');
  // ⚠️ L’UNITÉ EST ABRÉGÉE, et ce repère est DISCRET par dessein : « il y a 30 s » tient sous un
  //    tableau là où « il y a 30 secondes » pousse la ligne. Le texte est figé par deux tests.
  // ⚠️ ET CE N’EST PAS UNE PHRASE COMPTÉE : « s » et « min » sont des symboles d’unité, invariables
  //    dans les trois langues. Le trou ne s’appelle donc PAS `{n}` — ce nom-là annonce au moteur
  //    qu’il doit choisir une forme, et la garde des pluriels en réclamerait une qui n’existe pas.
  if (secondes < 60) return t('vérifié il y a {delai} s', { delai: secondes });
  return t('vérifié il y a {delai} min', { delai: Math.round(secondes / 60) });
}
